import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { RateBadge } from "../services/topServicesTableCells";
import type { TeamStaffRow } from "./types";

export function TeamRankCell({ rank }: { rank: number }) {
  return (
    <div className="flex h-full items-center justify-center">
      <RateBadge rate={rank} />
    </div>
  );
}

export function TeamStaffNameCell({ row }: { row: TeamStaffRow }) {
  return (
    <div className="mx-auto flex min-w-[120px] items-center justify-center gap-2">
      <Avatar className="size-8 shrink-0">
        {row.photoUrl ? (
          <AvatarImage src={row.photoUrl} alt={row.name} />
        ) : null}
        <AvatarFallback className="text-xs font-medium">
          {row.initials}
        </AvatarFallback>
      </Avatar>
      <div className="flex min-w-0 flex-col items-start text-left">
        <span className="truncate text-sm font-medium leading-none text-[#171717]">
          {row.name}
        </span>
        <span className="text-xs leading-normal text-[#737373]">
          {row.role}
        </span>
      </div>
    </div>
  );
}

const metricVariantClassName = {
  default: "text-[#171717]",
  positive: "font-medium text-emerald-600",
  warning: "font-medium text-red-600",
} as const;

export function TeamMetricCell({
  value,
  variant = "default",
}: {
  value: string | number;
  variant?: keyof typeof metricVariantClassName;
}) {
  return (
    <span
      className={cn("text-sm leading-none", metricVariantClassName[variant])}
    >
      {value}
    </span>
  );
}
